import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Breadcrumbs,
  Typography,
  TextField,
  Grid,
  Button,
  DialogContent,
  DialogTitle,
  Dialog,
} from '@material-ui/core';
import { updateStoreEmailsApi } from 'api';


const SendingEmail = ({ primaryEmailField, setPrimaryEmailField }) => {
  const dispatch = useDispatch();
  const regexSendingEmails = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;

  const [incorrectEmail, setIncorrectEmail] = useState(false);
  const [isTouchedEmailField, setIsTouchedEmailField] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const updateSendingEmails = async () => {
    const isEmailUpdate = await updateStoreEmailsApi({
      dispatch,
      updateEmailsData: {
        primaryEmail: primaryEmailField,
        receivingEmail: primaryEmailField,
        appointmentEmail: primaryEmailField,
      },
    });

    if (isEmailUpdate) {
      setIsOpen(false);
    }
  };

  const handleEmailChange = (event) => {
    const { value } = event.target;
    setPrimaryEmailField(value);
    value.match(regexSendingEmails)
      ? setIncorrectEmail(false)
      : setIncorrectEmail(true);
  };

  const handleBlurEmailField = () => {
    setIsTouchedEmailField(true);
  };

  return (
    <div className="m-5 text-dark-gray">
      <Typography variant="h6" color="primary">
        Configure your Sending Email Account, which will serve as your Primary Store Email.
      </Typography>
      <div className="mb-3">
        Your Sending Email account is the email address that sends all of the email communications from your store.
        We recommend that you set up a new, dedicated Email Account for this
      </div>
      <div className="flex mt-5 mb-3">
        <div>
          <Typography variant="h6" color="primary">
            To purchasers and account holders:
          </Typography>
          <ul>
            <li>a welcome email when a store account is created</li>
            <li>order-confirmation emails</li>
            <li>other transactional emails you can send such as shipping emails or order updates</li>
            <li>abandoned cart reminders</li>
            <li>e-gift card updates</li>
            <li>review reminders/requests</li>
            <li>subscription-related emails such as payment failure notifications (if you have auto-replenish subscriptions or memberships)</li>
            <li>
              other emails to account-holders based on whether you have features enabled on your store
              <ul>
                <li>Birthday Offers</li>
                <li>Reward Points Activity</li>
                <li>Reward Points Expiration notifications</li>
                <li>Request Access status approval or rejection</li>
              </ul>
            </li>
          </ul>
        </div>
        <div>
          <Typography variant="h6" color="primary">
            To you, the store owner:
          </Typography>
          <ul>
            <li>
              Order-based emails (the same transactional emails that are sent to the purchaser are BCCd to the practice)
            </li>
            <li>
              On Hold Order Notifications (in case of a high fraud riskScore)
            </li>
            <li>
              Contact Form submittals (all Stores have a contact form)
            </li>
            <li>
              Subscription-related emails such as payment failure notifications (if you have auto-replenish subscriptions or memberships)
            </li>
            <li>
              Request Access notifications (if you have skinbetter science or other restricted brands enabled on your store)
            </li>
            <li>
              Appointment Form submittals (if you have a Premium Store with an Appointment Form)
            </li>
          </ul>
        </div>
      </div>
      <Grid item xs={12} className="flex">
        <Grid item xs={5}>
          <TextField
            required
            value={primaryEmailField}
            onChange={handleEmailChange}
            onBlur={handleBlurEmailField}
            fullWidth
            className="pr-5"
            name="sending-email"
            label="orders@yourdomain.com"
            InputLabelProps={{
              shrink: !!primaryEmailField,
              style: { fontStyle: 'italic' },
            }}
            variant="outlined"
            error={isTouchedEmailField && incorrectEmail}
            helperText={
              isTouchedEmailField &&
              incorrectEmail &&
              'Please enter a valid email address'
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="contained"
            color="primary"
            disabled={!primaryEmailField || incorrectEmail}
            onClick={() => setIsOpen(true)}
          >
            Submit Primary Email
          </Button>
          <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
            maxWidth={'sm'}
            fullWidth
          >
            <DialogTitle>
              <Typography variant="h5" className="mt-4">
                I will be responsible for the creation of this email account.{' '}
                <br />
                This email address is not an alias or a distribution group
                address.
              </Typography>
            </DialogTitle>
            <DialogContent className="m-4 flex justify-end">
              <div className="mt-5">
                <Button
                  color="primary"
                  variant="contained"
                  className="mr-3"
                  onClick={updateSendingEmails}
                >
                  I Agree
                </Button>
                <Button variant="contained" onClick={() => setIsOpen(false)}>
                  Cancel
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </Grid>
      </Grid>
      <div className="my-10 text-dark-gray">
        This email will be used as both the sender and recipient for all communications from the store. After your store is live you, remember to visit{' '}
        <Breadcrumbs separator="›" aria-label="breadcrumb" className="inline-block">
          <Typography color="textPrimary">Shop Manager</Typography>
          <Typography color="textPrimary">Settings</Typography>
          <Typography color="textPrimary">Store Configurations</Typography>
          <Typography color="textPrimary">Store Emails</Typography>
          <Typography color="textPrimary">Receiving Emails</Typography>
        </Breadcrumbs>{' '}
        to configure a variety of recipients for the various email communications from your store.
      </div>
    </div>
  );
};

export default SendingEmail;
